import * as React from "react";
import ValidateError from "./ValidateError";

interface ValidateInputProps {
  className?: string;
  name: string;
  onChange: Function;
  onUpdate: Function;
  _onFocus?: Function;
  onBlur?: Function;
  onKeyDown?: Function;
  inputValue: any;
  placeholder?: string;
  type?: string;
  input?: any;
  meta?: any;
  label?: string;
  maxlength?: number;
  getRef?: Function;
  tabIndex?: number;
}

export default class ValidateInput extends React.Component<
  ValidateInputProps,
  any
> {
  public static defaultProps = {
    type: "text",
    label: "",
    className: "form-control",
  };

  constructor(props) {
    super(props);
  }

  renderInput() {
    const {
      input,
      label,
      getRef,
      tabIndex,
      inputValue,
      className,
      maxlength,
      _onFocus,
      meta,
      placeholder,
    } = this.props;

    let inputType = this.props.type;

    // temporary way to separate new-validated/old-non-validated input types
    if (~inputType.indexOf("validate")) {
      inputType = inputType.replace("validate", "").toLowerCase();
    }

    const inputProps = {
      ...input,
      tabIndex,
      className,
      maxLength: maxlength,
      type: inputType,
      ref: getRef,
      placeholder: label || placeholder,
      onFocus: _onFocus,
      onKeyDown: ev => {
        if (this.props.onKeyDown) {
          this.props.onKeyDown(ev, { meta });
        }
      },
      onChange: ev => {
        if (this.props.onUpdate) {
          this.props.onUpdate(ev);
        }
        input.onChange(ev);
      },
    };

    if (inputValue || inputValue === false) {
      // setting value conflicts when using initialValues
      return <input {...inputProps} value={inputValue} />;
    }
    return <input {...inputProps} />;
  }

  render() {
    const { meta, className } = this.props;
    const errorClassName = className.split(" ").pop();
    return (
      <div>
        {this.renderInput()}
        {meta.touched &&
          meta.error && (
            <ValidateError className={errorClassName} text={meta.error} />
          )}
      </div>
    );
  }
}
